var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49933 10.3648L11.9112 17.1475C12.0238 17.2667 12.1749 17.3333 12.3322 17.3333C12.4894 17.3333 12.6405 17.2667 12.7531 17.1475L19.1674 10.3648C19.2199 10.3093 19.2617 10.243 19.2902 10.1697C19.3187 10.0964 19.3334 10.0177 19.3334 9.93812C19.3334 9.85857 19.3187 9.77983 19.2902 9.70654C19.2617 9.63325 19.2199 9.56691 19.1674 9.51141C19.0597 9.39725 18.9151 9.33334 18.7646 9.33334C18.614 9.33334 18.4694 9.39725 18.3617 9.51141L12.3322 15.8897L6.30383 9.51142C6.19618 9.39764 6.05185 9.33397 5.90158 9.33397C5.75131 9.33397 5.60698 9.39764 5.49933 9.51142C5.44681 9.56691 5.40506 9.63325 5.37656 9.70654C5.34806 9.77983 5.33337 9.85857 5.33337 9.93812C5.33337 10.0177 5.34806 10.0964 5.37656 10.1697C5.40506 10.243 5.44681 10.3093 5.49933 10.3648Z",
    fill: "#62778E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.4616b5fe0314d12891ba3719a7f06dd4.svg";
export { ForwardRef as ReactComponent };